import Vue, { CreateElement, VNode } from "vue";
import App from "./App.vue";
import router from "./router";
import Multiselect from "vue-multiselect";
import VueMeta from "vue-meta";

/** import custom css style **/
import "@/assets/styles/style.scss";
// register service worker
import "./registerServiceWorker";

/** Import project plugins  */
import Fontawesome from "@/plugins/fontawesome";
import Buefy from "@/plugins/buefy";
import Filter from "@/plugins/filter";
import Gda from "@/plugins/gda";

Vue.use(Fontawesome);
// Vue.use(Buefy);
Vue.use(Buefy, { icon: "fontawesome" });
Vue.use(Filter);
Vue.use(Gda, {}); // pass gda client config as second parameter

Vue.use(VueMeta);
Vue.component("multiselect", Multiselect);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h: CreateElement): VNode => h(App),
}).$mount("#app");
